<template>
    <ContentPanel
        :headline="t('transformers.conditionStatus.content.oilHistoricalTrends.title')"
        :hide-content="!hasHistoricalTrendsChartData"
    >
        <template v-if="!hasHistoricalTrendsChartData" #context>
            <ColorBadge
                :color="StatusTypes[ConditionStatus.None].color"
                :text="t(StatusTypes[ConditionStatus.None].labelKey)"
                small
            />
        </template>
        <HistoricalTrendsChart
            v-if="isHistoricalTrendsFullSelection"
            :measurement-type="historicalTrendsSelection.measurementType"
            :measurement-point="historicalTrendsSelection.measurementPoint"
            :start-date="historicalTrendsSelection.startDate"
            :end-date="historicalTrendsSelection.endDate"
            :force-light-theme="isPdfLightTheme"
            hide-toolbox
            @update:has-data="onUpdateHistoricalTrendsChartHasData"
        />
    </ContentPanel>
</template>

<script setup lang="ts">
import { computed, ref, toRefs } from 'vue'
import ContentPanel from '@/components/panel/ContentPanel.vue'
import HistoricalTrendsChart from '@/pages/generators/condition-status/sections/historical-trends/HistoricalTrendsChart.vue'
import { provideGeneratorId } from '@/composables/useGeneratorId'
import { useRoute } from 'vue-router'
import { HistoricalTrendsSelector } from '@/pages/generators/condition-status/sections/historical-trends/historical-trends-types'
import { useI18n } from 'vue-i18n'
import ColorBadge from '@/components/badge/ColorBadge.vue'
import { ConditionStatus, StatusTypes } from '@/configuration/status/condition-status'
import { useExportPdfLightTheme } from '@/pages/exports/useExportPdfTheme'

const props = defineProps<{
    generatorId: string
}>()

const { generatorId } = toRefs(props)

const hasHistoricalTrendsChartData = ref(true)
const isPdfLightTheme = useExportPdfLightTheme()

const { t } = useI18n()
const { query } = useRoute()

const historicalTrendsSelection = computed<HistoricalTrendsSelector>(() => {
    const measurementType = parseInt(query.measurementType as string)
    const measurementPoint = parseInt(query.measurementPoint as string)

    return {
        startDate: query.startDate as string | undefined,
        endDate: query.endDate as string | undefined,
        measurementType: isNaN(measurementType) ? undefined : measurementType,
        measurementPoint: isNaN(measurementPoint) ? undefined : measurementPoint,
    }
})

const isHistoricalTrendsFullSelection = computed<boolean>(() => {
    return !!historicalTrendsSelection.value.startDate && !!historicalTrendsSelection.value.endDate && !!historicalTrendsSelection.value.measurementType
})

const onUpdateHistoricalTrendsChartHasData = (value: boolean) => (hasHistoricalTrendsChartData.value = value)

provideGeneratorId(generatorId)
</script>
